var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "193 20.223 193.339 19.933 197 16.796 196.322 16 193 18.846 189.678 16 189 16.796 192.661 19.933",
    transform: "translate(-189 -16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileChevron);
export default __webpack_public_path__ + "static/media/profile-chevron.b4dad20eb9f73256ae06659dd1aebfb4.svg";
export { ForwardRef as ReactComponent };